var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIdeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 147 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.413 33.736v68.376h41.543c25.085 0 38.731-11.686 38.731-34.276 0-23.215-14.792-34.1-38.731-34.1H33.413zm41.543-3.549c36.787 0 42.28 23.59 42.28 37.649 0 24.393-15.014 37.825-42.28 37.825H29.864V30.187h45.092z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.043 57.236v7.714h2.368c1.641 0 3.157-.474 3.157-3.918 0-3.366-1.687-3.796-3.157-3.796h-2.368zm39.504-3.839h3.831V64.95h5.677c-1.557-20.963-18.048-25.491-33.033-25.491H59.046v13.946h2.365c4.311 0 6.99 2.924 6.99 7.627 0 4.853-2.614 7.749-6.99 7.749h-2.365v27.906h15.976c24.364 0 32.842-11.314 33.141-27.906h-9.616V53.397zm-10.673 8.584h2.771l-1.266-4.348h-.231l-1.274 4.348zm-5.978 6.805l4.639-15.389h5.45l4.637 15.389h-3.987l-.869-2.977h-5.011l-.872 2.977h-3.987zm-1.84-3.836v3.831H70.58V53.403h9.17v3.83h-5.339v1.783h5.05v3.827h-5.05v2.107h5.645zM54.03 61.086a8.265 8.265 0 01-16.53 0 8.266 8.266 0 0116.53 0zm-14.894 35.59h13.298V73H39.136v23.674z",
    fill: "currentColor"
  })));
}

var MemoSvgIdeal = /*#__PURE__*/React.memo(SvgIdeal);
export default MemoSvgIdeal;